var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUserList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50398 2.25C7.0271 2.25 5.00398 4.23662 5.00398 6.70588C5.00398 9.17514 7.0271 11.1618 9.50398 11.1618C11.9809 11.1618 14.004 9.17514 14.004 6.70588C14.004 4.23662 11.9809 2.25 9.50398 2.25ZM6.50398 6.70588C6.50398 5.08174 7.83874 3.75 9.50398 3.75C11.1692 3.75 12.504 5.08174 12.504 6.70588C12.504 8.33003 11.1692 9.66177 9.50398 9.66177C7.83874 9.66177 6.50398 8.33003 6.50398 6.70588Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50398 12.8382C5.33072 12.8382 1.87196 15.9063 1.32817 19.9014C1.18307 20.9674 2.06929 21.75 3.00398 21.75H16.004C16.9387 21.75 17.8249 20.9674 17.6798 19.9014C17.136 15.9063 13.6772 12.8382 9.50398 12.8382ZM2.81447 20.1037C3.25661 16.8554 6.07754 14.3382 9.50398 14.3382C12.9304 14.3382 15.7514 16.8554 16.1935 20.1037C16.1976 20.134 16.1911 20.1591 16.1639 20.1875C16.1323 20.2204 16.0763 20.25 16.004 20.25H3.00398C2.93165 20.25 2.87563 20.2204 2.84407 20.1875C2.81687 20.1591 2.81034 20.134 2.81447 20.1037Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.004 5.75L22.004 5.75V4.25L16.004 4.25V5.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.004 8.75L22.004 8.75V7.25L16.004 7.25V8.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.004 11.75H22.004V10.25H19.004V11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserList);
export default __webpack_public_path__ + "static/media/ic_user-list.f1735587a50fed3511a3e345e08925a6.svg";
export { ForwardRef as ReactComponent };